import { createApp } from 'vue'
import App from './App.vue';
import routes from './router/routes'
import "bootstrap/dist/js/bootstrap.min.js"
import "bootstrap/dist/js/bootstrap.esm.min.js"
import "bootstrap/dist/js/bootstrap.js"
import "@mdi/font/css/materialdesignicons.min.css"
import "./assets/css/main.css";

createApp(App)
    .use(routes)
    .mount('#app')